export default "__VITE_ASSET__de06d793__"